import { ConfirmationModal } from '../../Modal';
import { useToast } from '../../../Contexts/ToastContext';
import usePostRegenerateInvoice from '../../../hooks/usePostRegenerateInvoice';

const DEFAULT_ERROR_MESSAGE = 'An error occurred while regenerating the invoice. Please try again.';

const ReprintModal = ({ open, onClose, onSuccess, invoiceId }) => {
    const { showSuccessToast, showErrorToast } = useToast();
    const { mutate: regenerateInvoice, isLoading } = usePostRegenerateInvoice({
        onSuccess: () => {
            onSuccess?.();
            showSuccessToast('Invoice regeneration has been queued up successfully');
            onClose();
        },
        onError: (error) => {
            console.error('Error regenerating invoice', error);
            showErrorToast(error?.message || DEFAULT_ERROR_MESSAGE);
        },
    });

    const handleReprint = () => {
        regenerateInvoice({ invoiceId });
    };

    return (
        <ConfirmationModal
            open={open}
            title="Confirm Reprint"
            subtitle="Are you sure you would like to reprint this invoice? A full credit memo will be generated for the selected invoice."
            onConfirm={handleReprint}
            onClose={onClose}
            isLoading={isLoading}
            actionButtonLabel="Reprint"
            actionButtonColor="primary"
        />
    );
};

export default ReprintModal;
